import * as d3 from "d3";

export const getSizeElements = (ref: HTMLDivElement): { width: number; height: number } => {
    const height = (ref as Element)?.getBoundingClientRect()?.height ?? ref.clientHeight;
    const width = (ref as Element)?.getBoundingClientRect()?.width ?? ref.clientWidth;
    return {
        width,
        height
    };
};

export const createSVGElementIfNotExist = (
    shouldCreate: boolean,
    ref: HTMLElement,
    createFn: (element: HTMLElement) => d3.Selection<Element, unknown, null, undefined>,
    selectStr: string
): d3.Selection<Element, unknown, null, undefined> => {
    if (shouldCreate) {
        return createFn(ref);
    }
    return d3.select(ref).select(selectStr);
};
